<template>
    <div class="wizard-step">
        <div class="wizard-step__inner">
            <div class="wizard-step-head wizard-step-head_full pt-0 mb-24">
                <div class="wizard-step-head__inner">
                    <div class="container">
                        <el-row :gutter="12" type="flex" class="wizard-step-head__row">
                            <el-col :span="6">
                                <button v-if="!read" type="button" class="btn btn_primary" @click="elDialogs.areas = true">Добавить область профессиональной деятельности</button>
                            </el-col>

                            <el-col :span="6" :offset="4" v-show="!IS_PANEL_OPEN">
                                <v-select class="select" placeholder="Группировка" :value="groupItemsBy.label" :clearable="false" :options="groupItemsOpts" :disabled="!groupKinds.length" @input="setItemsGroup">
                                    <template #no-options="{ search, searching, loading }">
                                        {{ SELECT_NOT_FOUND }}
                                    </template>
                                    <template #open-indicator="{ attributes }">
                                        <span v-bind="attributes">
                                            <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                        </span>
                                    </template>
                                </v-select>
                            </el-col>

                            <el-col :span="!IS_PANEL_OPEN ? 8 : 24">
                                <div class="wizard-step-head__extra">
                                    <form
                                        class="search-form wizard-step-head__grow"
                                        @submit.prevent
                                    >
                                        <div class="search-form__inner">
                                            <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': searchInput && searchInput.length !== 0 }" placeholder="Поиск" :disabled="!kinds.length" v-model.trim="searchInput" @keydown.enter.prevent.stop>

                                            <button v-if="searchInput && searchInput.length !== 0" class="search-form__reset" @click="searchInput = ''">
                                                <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                                            </button>

                                            <button type="submit" class="search-form__submit">
                                                <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                                            </button>
                                        </div>
                                    </form>

                                    <button class="collapse-btn ml-12" :disabled="!kinds.length" @click="checkAccordions ? closeAccordions() : openAccordions()">
                                        <icon-base viewBox="0 0 14 8" class="collapse-btn__icon" :class="{'collapse-btn__icon_active': !checkAccordions}"><icon-arrow-top /></icon-base>
                                    </button>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>

            <div class="wizard-step__content">
                <div class="container">
                    <accordion v-if="groupKinds.length">
                        <accordion-item ref="accordionItem" :bus="bus" parent v-for="(groupKind, index) in groupKinds" :key="groupKind.groupId">
                            <template #accordion-head>
                                <div class="accordion__head" tabindex="0">
                                    <div class="accordion__head-item" v-html="groupKind.name">
                                    </div>
                                    
                                    <div  class="accordion__head-item">
                                        <button v-if="!read" type="button" class="action-btn accordion__action" @click.stop="openKindsDialog(groupKind)">
                                            <span class="action-btn__text">Создать или найти ВПД</span>

                                            <span class="action-btn__helper">
                                                <icon-base viewBox="0 0 12 12" class="action-btn__icon"><icon-action /></icon-base>
                                            </span>
                                        </button>

                                        <selector-btn v-if="!read" class="ml-12" :options="accordionHeadOptionsForBtn" :params="{'id': groupKind.groupId}" :inAccordion="true" @clickOnItem="callback"></selector-btn>

                                        <icon-base viewBox="0 0 14 8" class="accordion__arrow">
                                            <icon-arrow-down />
                                        </icon-base>
                                    </div>
                                </div>
                            </template>

                            <el-table
                                cell-class-name="table__cell"
                                class="table table_top-scroll"
                                header-cell-class-name="table__title"
                                ref="table"
                                row-key="id"
                                :sort-orders="['ascending', 'descending']"
                                :data="filteredItemsBySearch(groupKind.items)"
                            >
                                <el-table-column
                                    width="24"
                                    v-if="!read"
                                >
                                    <template slot="header" slot-scope="scope">
                                        <div class="table_flex">
                                            <el-checkbox v-if="updateCheckboxAll" @change="toggleAllSelection(filteredItemsBySearch(groupKind.items), groupKind.groupId, $event)" :checked="selection[groupKind.groupId] ? filteredItemsBySearch(groupKind.items).length === selection[groupKind.groupId].length : false" />
                                        </div>
                                    </template>
                                    <template slot-scope="scope">
                                        <div class="table_flex">
                                            <el-checkbox v-if="updateCheckbox" @change="handleSelectionChange([scope.row], groupKind.groupId, $event)" :checked="handleSelectionValue([scope.row], groupKind.groupId)" />
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    width="48"
                                >
                                    <template slot="header" slot-scope="scope">
                                        <button type="button" class="settings-btn-main" @click="elDialogs.tableSettings = true">
                                            <icon-base viewBox="0 0 14 14" class="settings-btn__icon"><icon-settings-main /></icon-base>
                                        </button>
                                    </template>

                                    <template v-if="!read && scope.row.id !== 0" slot-scope="scope">
                                        <selector-btn :options="accordionTableOptionsForBtn" :params="{ index: index, groupId: groupKind.groupId, curId: scope.row.id }" portal="selectorModal" @clickOnItem="callback"></selector-btn>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="Код"
                                    sortable
                                    min-width="100"
                                    v-if="kindsSettings.find((item) => item.name === 'code' && item.visible)"
                                >
                                  <template slot scope="scope">
                                    <span v-if="scope.row.id === 0">–</span>
                                    <span v-else>{{scope.row.code}}</span>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                    label="Название ВПД"
                                    prop="name"
                                    sortable
                                    min-width="400"
                                >
                                    <template slot="header" slot-scope="scope">
                                        <span :forceUpdate="forceUpdate" v-if="!selection[groupKind.groupId] || (selection[groupKind.groupId] && !selection[groupKind.groupId].length)">Название ВПД</span>

                                        <button :forceUpdate="forceUpdate" type="button" class="btn btn_danger-second btn_small" v-if="selection[groupKind.groupId] && selection[groupKind.groupId].length" @click.stop="deleteItems({ index: index, groupId: groupKind.groupId })">
                                            Удалить выбранные
                                        </button>
                                    </template>

                                    <template slot-scope="scope">
                                        <a href="#"
                                           v-html="scope.row.name"
                                           @click.prevent.stop="openStandard(scope.row.standard_id, scope.row.id, scope.row.purpose, scope.row.lifecycle_id)">
                                        </a>
<!--                                        <span @click.prevent.stop="openStandard(null, scope.row.id, scope.row.purpose, scope.row.lifecycle_id)" v-else> {{scope.row.name}} </span>-->
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    sortable
                                    :label="groupItemsBy.name === 'area_id' ? 'Жизненный цикл' : 'ОПД'"
                                    :min-width="groupItemsBy.name === 'area_id' ? 200 : 400"
                                    :prop="groupItemsBy.name === 'area_id' ? 'lifecycle_id' : 'area_id'"
                                    v-if="kindsSettings.find((item) => item.name === 'lifecycle' && item.visible)"
                                >
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.lifecycle_id">
                                           {{ groupItemsBy.name === 'area_id' ? GET_LIFECYCLE_BY_ID(scope.row.lifecycle_id).name : GET_AREA_BY_ID(scope.row.area_id).name }}
                                        </span>
                                        <span v-else>
                                          –
                                        </span>

                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="Название стандарта"
                                    prop="standard_name"
                                    sortable
                                    min-width="300"
                                    v-if="kindsSettings.find((item) => item.name === 'standard_name' && item.visible)"
                                >
                                  <template scope="scope">
                                    <span v-if="scope.row.id === 0">Квалификации, не привязанные к профстандарту</span>
                                    <span v-else>{{scope.row.standard_name}}</span>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    width="48"
                                >
                                    <template slot-scope="scope">
                                        <el-tooltip content="Информация о ПК" placement="bottom-end">
                                            <a href="#" class="table__qual-icon" @click.prevent.stop="openQualifications(scope.row.id)">
                                                <icon-base width="16" height="20" viewBox="0 0 16 20">
                                                    <icon-doc />
                                                </icon-base>
                                            </a>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </accordion-item>
                    </accordion>
                </div>
            </div>
        </div>

        <reference-button v-if="hintsCode && elPanels.qualifications === 0" :hasFooter="hasFooter" :hintsCode="hintsCode" :content="hints.content" />

        <!-- DIALOGS -->
        <areas-dialog />
        <kinds-dialog :kindsLoader="kindsLoader" />
        <table-settings-dialog :settings="kindsSettings" @saveTableSettings="changeTableColums" />
        <!-- /DIALOGS -->

        <!-- PANELS -->
        <standard-panel
            v-if="activeKindId"
            :read="read"
            :kindGoal="activeKindPurpose"
            :kindId="activeKindId"
            :lifecycleId="activeLifecycleId"
            :okzsLoader="okzsLoader"
            :okvedsLoader="okvedsLoader"
            :workFunctionsByStandardLoader="workFunctionsByStandardLoader"
        />

        <qualifications-panel
            v-if="activeKindId != undefined"
            :kindId="activeKindId"
        />
      <!-- PANELS -->
      <qualification-panel
          v-if="qualification"
          :read="read"
          :workFunctionsByQualificationLoader="false"
          :programsByQualificationLoader="false"
          :standartLoader="false"
      />
        <!-- /PANELS -->
    </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import constants from '@/constants.js';
import step from '@/mixins/step';

import Accordion from '@/components/Accordion/Accordion';
import AccordionItem from '@/components/Accordion/AccordionItem';
import AreasDialog from '@/components/Dialogs/AreasDialog';
import KindsDialog from '@/components/Dialogs/KindsDialog';
import KindsStep from '@/components/WizardSteps/KindsStep';
import QualificationsPanel from '@/components/WizardPanels/QualificationsPanel';
import StandardPanel from '@/components/WizardPanels/StandardPanel';
import Tab from '@/components/Tabs/Tab';
import TableSettingsDialog from '@/components/Dialogs/TableSettingsDialog';
import Tabs from '@/components/Tabs/Tabs';
import SelectorBtn from '@/components/SelectorBtn';
import ReferenceButton from "../ReferenceButton";
import QualificationPanel from "@/components/WizardPanels/QualificationPanel.vue";

export default {
    mixins: [ step ],
    components: {
        Accordion,
        AccordionItem,
        AreasDialog,
        KindsDialog,
        KindsStep,
        QualificationsPanel,
        StandardPanel,
        Tab,
        TableSettingsDialog,
        Tabs,
        SelectorBtn,
        ReferenceButton,
        QualificationPanel,
    },
    props: {
        read: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            bus: new Vue(),
            isMounted: false,
            forceUpdate: 1,
            updateCheckbox: true,
            updateCheckboxAll: true,

            activeKindId: null,
            activeKindPurpose: null,
            activeLifecycleId: null,

            kindsLoader: false,
            okzsLoader: false,
            okvedsLoader: false,
            workFunctionsByStandardLoader: false,
            hasFooter: true,
            hintsCode: 'KindsStep',

            searchValue: null,
            selection: {},

            kindsSettings: [
                {
                    name: 'code',
                    title: 'Код',
                    visible: true,
                    default: false
                },
                {
                    name: 'name',
                    required: true,
                    title: 'Название',
                    visible: true,
                    default: true
                },
                {
                    name: 'standard_name',
                    title: 'Название стандарта',
                    visible: true,
                    default: false
                },
                {
                    name: 'lifecycle',
                    title: 'Жизненный цикл',
                    visible: true,
                    default: true
                },
            ],

            groupItemsOpts: [
                {
                    name: 'area_id',
                    label: 'По ОПД'
                },
                {
                    name: 'lifecycle_id',
                    label: 'По жизненному циклу'
                }
            ],
            accordionHeadOptionsForBtn: [
                {
                    name: 'Удалить',
                    warning: true,
                    callback: 'deleteArea',
                }
            ],
            accordionTableOptionsForBtn: [
                {
                    name: 'Удалить',
                    warning: true,
                    callback: 'deleteItems'
                }
            ]
        }
    },
    methods: {
        ...mapActions('editor', [
            'LOAD_KINDS_BY_AREA',
            'LOAD_QUALIFICATIONS_BY_KIND',
            'LOAD_STANDARD',
            'SILENT_LOAD_OKZS',
            'SILENT_LOAD_OKVEDS',
            'SILENT_LOAD_WORK_FUNCTIONS_BY_STANDARD',
            'DELETE_KINDS',
            'SILENT_LOAD_QUALIFICATIONS'
        ]),
        ...mapActions('listsForEditor', [
            'SILENT_LOAD_ALL_KINDS',
        ]),
        ...mapActions('hints', [
            'LOAD_HINTS',
        ]),
        ...mapMutations('common', [
            'TOGGLE_DIALOG',
            'TOGGLE_PANEL',
        ]),
        ...mapMutations('editor', [
            'SET_STANDARD',
            'SET_ITEMS_GROUP',
            'SET_SELECTED_AREAS',
            'GROUP_KINDS'
        ]),
        
        closeAccordions() {
            this.bus.$emit('closeAccordion');
        },
        openAccordions() {
            this.bus.$emit('openAccordion');
        },

        callback(emitObj) {
            this[emitObj.callback](emitObj.args)
        },
        changeTableColums(settings) {
            this.kindsSettings = settings
        },

        handleSelectionChange(val, parentId, event) {
            if (event) this.selection[parentId] = [...val, ...(this.selection[parentId] ? this.selection[parentId] : [])];
            else {
                this.selection[parentId] = this.selection[parentId].filter(select => !val.find(item => item.id === select.id))
                if (this.selection[parentId].length === 0) delete this.selection[parentId]
            }
            this.forceUpdate++
            this.forceRerenderCheckboxAll()
        },
        toggleAllSelection(val, parentId, event) {
            if (event) this.selection[parentId] = [...val];
            else delete this.selection[parentId]
            this.forceUpdate++
            this.forceRerenderCheckbox()
        },
        handleSelectionValue(val, parentId) {
            return this.selection[parentId] ? !!this.selection[parentId].filter(select => val.find(item => item.id === select.id)).length : false
        },
        forceRerenderCheckbox() {
            this.updateCheckbox = false;

            this.$nextTick(() => {
                this.updateCheckbox = true;
            });
        },
        forceRerenderCheckboxAll() {
            this.updateCheckboxAll = false;

            this.$nextTick(() => {
                this.updateCheckboxAll = true;
            });
        },

        setItemsGroup(value) {
            this.SET_ITEMS_GROUP(value);
            this.GROUP_KINDS(value.name);
        },
        filteredItemsBySearch(items) {
            return this.searchInput ? items.filter(item => item.name.toLowerCase().includes(this.searchInput.toLowerCase())) : items
        },

        async deleteArea({ id }) {

            if (id === 0) {
              console.log('Удаляем пустой ОПД');
              await this.DELETE_KINDS([0]);
              await this.SILENT_LOAD_QUALIFICATIONS();
              await this.GROUP_KINDS('area_id')
              return;
            }

            const newSelection = this.selectedAreas.filter((item) => item.id !== id);

            await this.SET_SELECTED_AREAS(newSelection);
            await this.GROUP_KINDS('area_id')

            const tempKindList = await this.LOAD_KINDS_BY_AREA(id);

            await this.DELETE_KINDS(tempKindList.map((item) => item.id) || []);
        },
        async deleteItems({ index, groupId, curId }) {
            if (groupId === 0) {
                console.log('Удаляем пустой ОПД');
                await this.DELETE_KINDS([0]);
                await this.SILENT_LOAD_QUALIFICATIONS();
                await this.GROUP_KINDS('area_id')
                return;
            }
            if (curId) await this.DELETE_KINDS(curId);
            else await this.DELETE_KINDS(this.selection[groupId].map((item) => item.id));

            this.selection = [];
            console.log('this.selection: ', this.selection);
        },

        async openStandard(id = null, kindId, kindPurpose, lifecycleId) {
            if (id) await this.LOAD_STANDARD(id)
            else this.SET_STANDARD({})

            console.log('open vpd', kindPurpose);

            this.activeKindId = kindId;
            this.activeKindPurpose = kindPurpose;
            this.activeLifecycleId = lifecycleId

            this.elPanels.standard = 1;
            this.elPanels.qualifications = 0;

            if (id) {
                this.okzsLoader = true
                this.okvedsLoader = true
                this.workFunctionsByStandardLoader = true

                await this.loadOkzs()
                await this.loadOkveds()
                await this.loadWorkFunctionsByStandard(id)
            }
        },
        async openQualifications(kindId) {
            // if (kindId === 0) {



            // } else {
              await this.LOAD_QUALIFICATIONS_BY_KIND(kindId);
            // }

            this.activeKindId = kindId;
            this.elPanels.qualifications = 1;
            this.elPanels.standard = 0;
        },
        async openKindsDialog(groupKind) {
            this.elDialogs.kinds = {
                addMode: true,
                visible: true,
                data: {
                    areaCode: groupKind.code,
                    groupId: groupKind.groupId
                }
            }
            if (this.allKindsList.length === 0) {
                this.kindsLoader = true
                await this.loadAllKinds()
            }
        },

        async loadAllKinds() {
            await this.SILENT_LOAD_ALL_KINDS()
            this.kindsLoader = false
        },
        async loadOkzs() {
            await this.SILENT_LOAD_OKZS(),
            this.okzsLoader = false
        },
        async loadOkveds() {
            await this.SILENT_LOAD_OKVEDS(),
            this.okvedsLoader = false
        },
        async loadWorkFunctionsByStandard(id) {
            await this.SILENT_LOAD_WORK_FUNCTIONS_BY_STANDARD(id)
            this.workFunctionsByStandardLoader = false
        },
    },
    computed: {
        ...mapGetters('common', ['IS_PANEL_OPEN']),
        ...mapGetters('editor', ['GET_AREA_BY_ID', 'GET_LIFECYCLE_BY_ID']),
        ...mapState('common', ['dialogs', 'panels']),
        ...mapState('editor', ['areas', 'groupItemsBy', 'groupKinds', 'kinds', 'selectedAreas', 'standard', 'qualification']),
        ...mapState('listsForEditor', ['allKindsList']),
        ...mapState('hints', ['hints']),

        checkAccordions() {
            if (!this.isMounted) return false
            else if (this.$refs.accordionItem && this.$refs.accordionItem.map(el => el.isActive).includes(true)) return true
            else return false
        }
    },
    watch: {
        searchInput: function() {
            this.forceRerenderCheckboxAll()
        },
        'elPanels.standard': function(val) {
            this.hasFooter = !val
            if (val === 1) this.hintsCode = 'StandartPanel'
            else if (val === 2) this.hintsCode = 'WorkFunctionsStandart'
            else this.hintsCode = 'KindsStep'
        }
    },
    created() {
        this.SELECT_NOT_FOUND = constants.SELECT_NOT_FOUND;
    },
    mounted() {
        this.isMounted = true;
    }
}
</script>
